import store from '@/plugins/vuex'

export default [
  {
    path: '/artist/my-vidcents',
    name: 'My VidCents',
    title: 'My VidCents',
    beforeEnter(to, from, next) {
      if (
        store.state.artistDashboard.artist_label == null &&
        store.state.auth.user.user_level == 'label_admin'
      ) {
        next({
          name: 'My Artists'
        })
      } else {
        next()
      }
    },
    component: () =>
      import(/* webpackChunkName: 'my-vidcents-artist' */ './views/Index.vue')
  }
]
